module.exports = __webpack_public_path__ + "img/logo.52f78d11.png";